<template>
    <div class="flex flex-col">
        <div class="flex justify-start sm:items-end flex-col sm:flex-row">
            <div class="flex flex-col mr-4">
                <label for="date">{{ $t("common.dateSelect.date") }}</label>
                <input
                    type="date"
                    :aria-label="$t('common.dateSelect.date')"
                    :title="$t('common.dateSelect.date')"
                    v-model="selectedDate"
                    @blur="blurAction"
                    @input="inputAction"
                    @keyup.enter="keyupEnter"
                    class="border rounded px-2 py-1 dark:bg-slate-950 bg-white text-primary-dark dark:text-white"
                />
            </div>
            <div class="flex items-end">
                <div class="flex flex-col">
                    <label for="hour">{{ $t("common.dateSelect.hour") }}</label>
                    <input
                        type="time"
                        :title="$t('common.dateSelect.time')"
                        name="hh%3Amm%3Ass"
                        :aria-label="$t('common.dateSelect.time')"
                        v-model="selectedTime"
                        @blur="blurAction"
                        @input="inputAction"
                        @keyup.enter="keyupEnter"
                        class="border rounded px-2 py-1 dark:bg-slate-950 bg-white text-primary-dark dark:text-white"
                    />
                </div>
                <slot name="button"></slot>
            </div>
        </div>

        <div class="flex py-2">
            <div v-if="enableUTC" class="flex">
                <label for="utcCheckbox" class="ml-2">
                    <input
                        type="checkbox"
                        id="utcCheckbox"
                        v-model="isUTC"
                        @change="blurAction"
                    />
                    {{ $t("common.dateSelect.utc") }}
                </label>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import type { DatesAdapter } from "inversify-utils-kit";
import { defineComponent, inject, ref } from "vue";

export default defineComponent({
    props: {
        value: {
            type: Number,
            default: () => null,
            required: true
        },
        enableUTC: {
            type: Boolean,
            default: () => false,
            required: false
        }
    },
    model: {
        prop: "value",
        event: "update:value"
    },
    emits: ["blur", "input", "enter", "update:value"],
    setup(props, { emit }) {
        const datesAdapter = inject("datesAdapter") as DatesAdapter;

        const [initialDate, initialTime] = datesAdapter
            .toFormat(props.value, "yyyy-MM-dd;HH:mm:ss")
            .split(";");
        const selectedDate = ref(initialDate);
        const selectedTime = ref(initialTime);
        const isUTC = ref(false);

        const buildPosix = (): number => {
            const dateToEvaluate = `${selectedDate.value} ${selectedTime.value}`;
            const result = datesAdapter.fromFormat(
                dateToEvaluate,
                "yyyy-MM-dd HH:mm:ss",
                !isUTC.value
            );
            return result;
        };
        const updateAction = () => {
            if (!selectedDate.value || !selectedTime.value) {
                console.log("no date or time");
                return;
            }
            const posix = buildPosix();
            emit("update:value", posix);
        };

        const blurAction = () => {
            updateAction();
            emit("blur");
        };
        const inputAction = () => {
            updateAction();
            emit("input");
        };
        const keyupEnter = () => {
            emit("enter");
        };

        return {
            isUTC,
            selectedDate,
            selectedTime,
            blurAction,
            inputAction,
            keyupEnter
        };
    }
});
</script>
